import { store } from '../../../../resources/frontend/js/store/index';

export const prefillProvince = () => {
    const countryCode = store.state.page.countryCode;

    switch (countryCode) {
    case 'ca':
        prefillProvinceCA();
    }
};

export const prefillProvinceCA = () => {
    if (!store.getters['form/fieldExists']('zipcode')) return;

    const zipcode = store.getters['form/getFieldData']('value', 'zipcode');
    const zipcodeFirstLetter = zipcode.charAt(0).toUpperCase();
    let state = '';

    switch (zipcodeFirstLetter) {
    case 'T': state = 'AB'; break;
    case 'V': state = 'BC'; break;
    case 'R': state = 'MB'; break;
    case 'E': state = 'NB'; break;
    case 'A': state = 'NL'; break;
    case 'B': state = 'NS'; break;
    case 'X': state = 'NT'; break;
    case 'K':
    case 'L':
    case 'M':
    case 'N':
    case 'P': state = 'ON'; break;
    case 'G':
    case 'H':
    case 'J': state = 'QC'; break;
    case 'S': state = 'SK'; break;
    case 'Y': state = 'YT'; break;
    case 'C': state = 'PE'; break;
    default: state = 'undefined'; break;
    }

    if (!store.getters['form/fieldExists']('province')) {
        store.commit('form/addField', {
            step: 0,
            name: 'province',
            data: { name: 'province' },
        });
    }

    store.commit('form/setFieldData', {
        name: 'province',
        key: 'value',
        value: state,
    });
};

